import {
  FETCH_DRIVERS_DATA,
  FETCH_DRIVERS_SUCCESS,
  FETCH_DRIVERS_FAILURE,
  FETCH_DRIVERS_DETAILS_DATA,
  FETCH_DRIVERS_DETAILS_SUCCESS,
  FETCH_DRIVERS_DETAILS_FAILURE,
} from "./actionTypes";

/**
 * @param {Object} params
 * @param {number} [params.page=1] - Page number (1-based)
 * @param {number} [params.limit=10] - Items per page
 */
export const fetchDriversData = (params = {}) => ({
  type: FETCH_DRIVERS_DATA,
  payload: {
    page: params.page ?? 1,
    limit: params.limit ?? 10,
  },
});

export const fetchDriversSuccess = (data) => ({
  type: FETCH_DRIVERS_SUCCESS,
  payload: data,
});

export const fetchDriversDetailsFailure = (error) => ({
  type: FETCH_DRIVERS_FAILURE,
  payload: error,
});

export const fetchDriversDetailsData = (id) => ({
  type: FETCH_DRIVERS_DETAILS_DATA,
  payload: id,
});

export const fetchDriversDetailsSuccess = (data) => ({
  type: FETCH_DRIVERS_DETAILS_SUCCESS,
  payload: data,
});

export const fetchDriversFailure = (error) => ({
  type: FETCH_DRIVERS_DETAILS_FAILURE,
  payload: error,
});
